import { useState } from 'react';
import { formatSalesValue } from './../../utils/formatUtils';
import { ImSpinner8 } from 'react-icons/im';

const AgeingDebtors = ({ debtData, error, loading }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    if (loading) {
        return (
            <div className="flex justify-center items-center py-8">
                <ImSpinner8 className="animate-spin text-xl text-blue-500" />
                <span className="ml-2 font-semibold">Loading Daily Sales Report...</span>
            </div>
        )
    }

    if (error) {
        return (
            <div className='text-center font-semibold mt-3 max-w-3xl p-3 border rounded-md mx-auto text-red-500 shadow-md'>
                {error}
            </div>
        )
    }

    if (!debtData || Object.keys(debtData).length === 0) {
        return <div className='text-center font-semibold mt-3 max-w-3xl p-3 border rounded-md mx-auto border-black shadow-md'>Data not available</div>;
    }

    const ageingCategories = ["0-30", "31-60", "61-90", "91-180", "181-365", "366+"];

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setModalOpen(true);
    };

    return (
        <div className='table-modal-left-responsive'>
            <table className='table-credit-left'>
                <thead>
                    <tr className='position-sticky'>
                        <th>Debtor Type</th>
                        {ageingCategories.map((category) => (
                            <th key={category}>
                                <button onClick={() => handleCategoryClick(category)}>{category}</button>
                            </th>
                        ))}
                        <th>Net Due</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className='font-semibold'>Individual</td>
                        {ageingCategories.map((category) => (
                            <td key={category}>
                                {formatSalesValue(debtData[category]?.totalInitial || 0)}
                            </td>
                        ))}
                        <td>{formatSalesValue(ageingCategories.reduce((sum, category) => sum + (debtData[category]?.totalInitial || 0), 0))}</td>
                    </tr>
                    <tr>
                        <td className='font-semibold'>Payments</td>
                        {ageingCategories.map((category) => (
                            <td key={category}>
                                {formatSalesValue(debtData[category]?.totalPayment || 0)}
                            </td>
                        ))}
                        <td>{formatSalesValue(ageingCategories.reduce((sum, category) => sum + (debtData[category]?.totalPayment || 0), 0))}</td>
                    </tr>
                    <tr>
                        <td className='font-semibold'>Remaining</td>
                        {ageingCategories.map((category) => (
                            <td key={category}>
                                {formatSalesValue(debtData[category]?.remainingTotal || 0)}
                            </td>
                        ))}
                        <td>{formatSalesValue(ageingCategories.reduce((sum, category) => sum + (debtData[category]?.remainingTotal || 0), 0))}</td>
                    </tr>
                </tbody>
            </table>

            {modalOpen && selectedCategory && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 modal-open py-4">
                    <div className="bg-white p-10 rounded shadow-lg relative max-h-full overflow-y-auto">
                        <h2 className='text-lg font-bold text-center'>Details for {selectedCategory} Days</h2>
                        <table className='table-credit-left'>
                            <thead>
                                <tr className='position-sticky '>
                                    <th>Customer Name</th>
                                    <th>Guest ID</th>
                                    <th>Initial Total</th>
                                    <th>Payment Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {debtData[selectedCategory]?.data?.length > 0 ? (
                                    debtData[selectedCategory].data.map((item) => (
                                        <tr key={item.guestID}>
                                            <td>{item.customerName}</td>
                                            <td>{item.guestID}</td>
                                            <td>{formatSalesValue(item.InitialTotal)}</td>
                                            <td>{formatSalesValue(item.PaymentTotal)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan='4'>No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className='flex justify-end'>
                            <button onClick={() => setModalOpen(false)} className="mt-2 bg-red-500 text-white px-4 py-2 rounded">Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AgeingDebtors;